var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"status-bubble",class:_vm.statusClass},[_c('span',{staticClass:"white-text fa",class:_vm.arrowClass}),_vm._v(_vm._s(Math.abs(_vm.stamp.num_stamps)))])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cbfd8ff","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/passport/LedgerItemValue.vue
// module id = gJyD
// module chunks = 0